import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

import uploadedSuccessfully from "assets/application_submitted.jpg";
import { FormActionButtons, FormActions, Typography } from "components";
import { DataFormsContext } from "context/DataFormsContext";
import { STEP_SESSION_STORAGE_KEY, usePersistentCurrentStep } from "hooks";
import { colors } from "styles/colors";
import { routes } from "routes";

import { ConsentText, Container, Content, ImageSuccess } from "./ConsentPage.css";

export const ConsentPage = () => {
  const navigate = useNavigate();
  const {resetData} = useContext(DataFormsContext);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setCurrentStep] = usePersistentCurrentStep(1);

  const onNewApplicationClick = async () => {
    await resetData();
    sessionStorage.setItem(STEP_SESSION_STORAGE_KEY, "1");
    setCurrentStep(1);
    navigate(routes.form);
  };

  const onConsentClick = () => {
    const consentLink = 'https://na3.documents.adobe.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhAsP24IDcg1tccmGtBerOPTIiMjiXB4Tmo4XKB3HToupt3S7pFA9MLlCTgj-dUFukI*'
    window.open(consentLink, '_blank', 'noopener,noreferrer');
  }

  return (
    <Container>
      <FormActions
        title="consent_page_title"
        form={
          <>
            <Content>
              <ImageSuccess
                src={uploadedSuccessfully}
                alt="uploaded successfully"
              />
              <ConsentText>
                <Typography variant='bodyBold' color={colors.error}>consent_page_text</Typography>
              </ConsentText>
            </Content>
            <FormActionButtons
              submitButtonType='button'
              rightButtonName='signConsent'
              leftButtonName="fileNewApplication"
              onButtonTypeClick={onConsentClick}
              onBack={onNewApplicationClick}
            />
          </>
        }
      />
    </Container>
  );
};
